import { render, staticRenderFns } from "./intergraMall.vue?vue&type=template&id=d88a5ce0&scoped=true"
import script from "./intergraMall.vue?vue&type=script&lang=js"
export * from "./intergraMall.vue?vue&type=script&lang=js"
import style0 from "./intergraMall.vue?vue&type=style&index=0&id=d88a5ce0&prod&lang=scss&scoped=true"
import style1 from "./intergraMall.vue?vue&type=style&index=1&id=d88a5ce0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d88a5ce0",
  null
  
)

export default component.exports